import { Order } from './order';
import { Organization } from './organization';
import { User } from './user';

export type OrderFormFilters = {
    status?: string;
    search?: string;
};

export type OrderForm = {
    _id?: string;
    title?: string;
    imageUrl: string;
    // Degrees to turn the photo clockwise so the form reads upright (read by the AI, DD-3814).
    imageRotation?: number | null;
    status: OrderFormStatus;
    createdAt: Date;
    createdBy: User;
    order?: Order;
    organization: Organization;
    formFields?: OrderFormFields;
    restorationData: RestorationData[];
    deliveryDate?: Date;
    deliveryTime?: {
        hour: number;
        minute: number;
    };
};

export type OrderFormFields = {
    patientPersonalIdentityNumber: OrderFormTextField;
    isValidPinFormat: boolean;
    patientFirstName: OrderFormTextField;
    patientLastName: OrderFormTextField;
    clinicName: OrderFormTextField;
    dentistFirstName: OrderFormTextField;
    dentistLastName: OrderFormTextField;
    constructionComment: OrderFormTextField;
    deliveryDate?: OrderFormTextField;
    deliveryTime?: OrderFormTextField;
    constructionColor: OrderFormTextField;
};

export interface OrderFormTextField {
    value: string;
    // 0–100 on forms read by Azure; null on forms read by the GPT-6 reader (DD-3814).
    confidence: number | null;
    // The field's main box as four corners (fractions of the photo, top-left first).
    bounds: { x: number; y: number }[];
    // Every place the value was read from (DD-3814); null on forms read by Azure.
    // `text` is what was read at that place, e.g. one line of the notes.
    regions?: { x0: number; y0: number; x1: number; y1: number; text?: string | null }[] | null;
}

export type RestorationData = {
    restorationType: OrderFormRestorationType;
    teeth?: string[];
    teethRange?: RestorationTeethRange[];
    jaw?: OrderFormRestorationJaw;
    material?: string;
    color?: string;
    isTemporary: boolean;
    isWarranty: boolean;
    isTioTandvard?: boolean;
    confidence: number;
};

export type RestorationTeethRange = {
    from: string;
    to: string;
};

export enum OrderFormRestorationType {
    CROWN = 'CROWN',
    BRIDGE = 'BRIDGE',
    POST = 'POST',
    IMPLANT_CROWN = 'IMPLANT_CROWN',
    IMPLANT_BRIDGE = 'IMPLANT_BRIDGE',
    PARTIAL_DENTURE = 'PARTIAL_DENTURE',
    FULL_DENTURE = 'FULL_DENTURE',
    RETENTION = 'RETENTION',
    CLASP_PLATE = 'CLASP_PLATE',
    GROWTH_ADAPTATION = 'GROWTH_ADAPTATION',
    ANCHORAGE = 'ANCHORAGE',
    EXPANSION = 'EXPANSION',
    ANTIAPNEA = 'ANTIAPNEA',
    SPLINT = 'SPLINT',
    UNKNOWN = 'UNKNOWN',
}

export enum OrderFormRestorationJaw {
    UPPER_JAW = 'UPPER_JAW',
    LOWER_JAW = 'LOWER_JAW',
    BOTH_JAWS = 'BOTH_JAWS',
}

export enum OrderFormStatus {
    CREATED = 'CREATED',
    PROCESSING = 'PROCESSING',
    READY = 'READY',
    ERROR = 'ERROR',
    ORDER_CREATED = 'ORDER_CREATED',
}
